/*
 * Model for topic label (intent summaries)
 */

define([
  "backbone",
  "messaging/messenger",
  "modules/topicsSplit/topic/touchPointLabel/touchPointLabelModel",
], function (Backbone, Messenger) {
  const TopicLabelModel = {};

  TopicLabelModel.topicLabel = Backbone.Model.extend({
    idAttribute: "summaryId",
    defaults: {
      summary: "",
    },
    _allowSave: function () {
      // Only save the model if the user is allowed to edit the Locale for the label.
      if (!Messenger.reqres.request("can:edit:locale", { languageId: this.get("languageId") })) {
        return false;
      }
      // Do not bother saving new labels with empty values.  The server will ignore them, so save bandwidth.
      // If it is not new, then it must be saved so the server can remove the label if it wants to.
      if (this.isNew() && !this.get("summary")) {
        return false;
      }
      return this.constructor.__super__._allowSave.apply(this, arguments);
    },
  });

  TopicLabelModel.topicLabels = Backbone.Collection.extend({
    model: TopicLabelModel.topicLabel,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "_thisObject.languageName");
    },
    //Create new topic label and add it to the collection
    addLabel: function (languageId) {
      const topicLabel = new TopicLabelModel.topicLabel({ languageId: languageId });
      this.add(topicLabel);
      return topicLabel;
    },
    backup: function () {
      this._backup();
      this.onSynced(function () {
        this._backup();
      }, this);
    },
    restore: function () {
      this.reset(this.clonedModels, {
        parse: true,
        silent: true,
      });
      this.dirty = this.wasDirty;
    },
    _backup: function () {
      this.wasDirty = this.dirty;
      this.clonedModels = [];
      this.forEach((model) => this.clonedModels.push(model.toJSON()));
    },
  });

  return TopicLabelModel;
});
